// extracted by mini-css-extract-plugin
export default {"usernameLink":"usernameLink-hn7fMQeO"};